import { useContext, useMemo, useRef, useState } from "react";
import { Outlet, useMatch, useRouteLoaderData } from "react-router";

import { AuthenticatorContext } from "@/contexts/AuthenticatorContext";
import { FarmContext } from "@/contexts/FarmContext";

import BillingMenubar from "@/components/BillingMenuBar/BillingMenubar";
import Header from "@/components/Header/Header";
import Menubar from "@/components/Menubar/Menubar";
import ErrorBoundary from "@/components/Utils/ErrorBoundary";

export const FarmComponent = ({ history }) => {
    const usuarioInfo = useRouteLoaderData("root");

    const selectorRef = useRef(null);
    const mapRef = useRef(null);
    const [dataSource, setDataSource] = useState({ loading: false, data: null });
    const [fields, setFields] = useState(null);
    const [menuIsOpen, setMenuIsOpen] = useState(null);
    const historyRef = useRef(null);
    historyRef.current = history;
    const [error, setError] = useState(false);

    const { refreshUser, signOut, userInfo } = useContext(AuthenticatorContext);
    const [ds] = useContext(FarmContext);

    const isBilling = useMatch("/billing/*");

    const personalInfo = useMemo(() => {
        const newPersonalInfo = { ...usuarioInfo };

        if (userInfo && newPersonalInfo) {
            if (userInfo.name) {
                newPersonalInfo.nombre = userInfo.name;
            }
            if (userInfo.family_name
        && userInfo.family_name !== `${newPersonalInfo.apellido_paterno || ""} ${newPersonalInfo.apellido_materno || ""}`) {
                const idx = userInfo.family_name.indexOf(" ");
                const splits = idx > -1 ? [userInfo.family_name.slice(0, idx), userInfo.family_name.slice(idx + 1)]
                    : [userInfo.family_name, ""];
                newPersonalInfo.apellido_paterno = splits[0] || "";
                newPersonalInfo.apellido_materno = splits[1] || "";
            }
        }

        return newPersonalInfo;
    }, [usuarioInfo, userInfo]);

    return (<>
        <div id="wrapper" className={(ds?.dataFarm?.acceso_limitado ? "acceso_limitado " : "") + (!menuIsOpen ? "sidebar-closed" : "sidebar-open")}>
            <Header dataUser={personalInfo} userInfo={userInfo} signOut={signOut}
                toggleSidebar={() => setMenuIsOpen(c => !c)}
            />
            {
                isBilling ?
                    <BillingMenubar setMenuIsOpen={setMenuIsOpen} />
                    :
                    <Menubar historyRef={historyRef} innerRef={selectorRef} mapRef={mapRef} userInfo={userInfo}
                        fields={fields} setFields={setFields} dataSource={dataSource} setDataSource={setDataSource} menuIsOpen={menuIsOpen} setMenuIsOpen={setMenuIsOpen}
                    />
            }
            <div id="sidebar-content">
                <ErrorBoundary name="Route" resetOnChange>
                    <Outlet context={{
                        personalInfo: personalInfo,
                        refreshUser: refreshUser,
                        usuarioInfo: usuarioInfo,
                        accountsData: dataSource.data,
                        fields: fields,
                        menuIsOpen: menuIsOpen,
                        mapRef: mapRef,
                        selectorRef: selectorRef,
                        error,
                        setError
                    }}
                    />
                </ErrorBoundary>
            </div>
        </div>
    </>);
};
